import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { AccountStructureService } from '@app/shared/services';
import { AccountCopyComponent } from './account-copy.component';
import { AccountCopyService } from './services/account-copy.service';

@NgModule({
    imports: [CommonModule, SharedModule, AccountCopyComponent],
    providers: [AccountCopyService, AccountStructureService],
})
export class AccountCopyModule {}
